<template>
  <span class="btn btn-xs p-0" @click="toggle()">
    <img :src="imgOn" v-if="status" />
    <img :src="imgOff" v-else />

    <template v-if="leftLabel !== '' && rightLabel !== ''">
      <span :class="{ 'switch': true, 'past': status }">{{ leftLabel }}</span>/<span :class="{ 'switch': true, 'past': !status }">{{ rightLabel }}</span>
    </template>
  </span>
</template>

<script>
export default {

  name: 'SwitchButton',

  props: {
    leftLabel: {
      type: String,
      required: false,
      default: ''
    },

    rightLabel: {
      type: String,
      required: false,
      default: ''
    }
  },

  data () {
    return {
      status: true,
      imgOn: null,
      imgOff: null
    }
  },

  mounted () {
    this.imgOn = require('../../assets/image/icon/switch_green.png')
    this.imgOff = require('../../assets/image/icon/switch_red.png')
    this.$emit('status', this.status)
  },

  methods: {
    toggle () {
      this.status = !this.status
      this.$emit('status', this.status)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/style/color.scss';

span.switch {
  margin-right: 1em;
  margin-left: 1em;
  color: #ccc;

  &.active {
    color: $main-color;
  }

  &.past {
    color: #000;
  }
}
</style>


// WEBPACK FOOTER //
// SwitchButton.vue?015ac9a7